import { CalendarClock, CheckCircle2, History, ListPlus, MessageSquareText, Pencil, RefreshCw, Send, Sparkles, UserCheck, Zap } from "lucide-react";
import { fmtDateTime } from "@/lib/format";
import { Panel } from "@/components/crm/Badges";
import { brand } from "@/lib/brand";

const ICONS = {
  creacion: Sparkles, asignacion: UserCheck, estado: RefreshCw, nota: MessageSquareText, tarea_creada: ListPlus,
  tarea_completada: CheckCircle2, tarea_reabierta: ListPlus, interaccion: Zap, edicion: Pencil, solicitud_cita: CalendarClock,
  reasignacion: UserCheck, mensaje_enviado: Send, sincronizacion: RefreshCw,
};

export const ActivityPanel = ({ activity }) => (
  <Panel title="Actividad" icon={History} testid="lead-activity-panel">
    <ol className="relative space-y-5 border-l border-slate-200 pl-5" data-testid="activity-list">
      {activity.map((a) => {
        const Icon = ICONS[a.type] || History;
        return (
          <li key={a.id} className="relative" data-testid={`activity-item-${a.type}`}>
            <span className="absolute -left-[31px] grid h-5 w-5 place-items-center rounded-full bg-white ring-1 ring-slate-200">
              <Icon className="h-3 w-3 text-[#1E6FD9]" />
            </span>
            <p className="text-sm">{brand(a.description)}</p>
            <p className="mt-0.5 text-xs text-slate-400">{brand(a.user_name)} · {fmtDateTime(a.created_at)}</p>
          </li>
        );
      })}
    </ol>
  </Panel>
);
